import { Header2, Header3 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './ServicePrice.css';

interface IServicePriceProps {
  price: string;
}

export const ServicePrice = ({ price }: IServicePriceProps) => {
  return (
    <div className={styles['price']}>
      <Header2>{price}</Header2>
      <Header3 fontWeight="normal">/день</Header3>
    </div>
  );
};
